import { useMutation, UseMutationResult, useQueryClient } from '@tanstack/react-query';

import { API_QUERY_KEYS } from 'api';
import { inviteConsultee } from '../methods';
import { InviteConsulteeRequest, InviteConsulteeResponse } from '../types';

export const useInviteConsultee = (): UseMutationResult<
  InviteConsulteeResponse,
  unknown,
  InviteConsulteeRequest
> => {
  const queryClient = useQueryClient();
  return useMutation(inviteConsultee, {
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [API_QUERY_KEYS.getConsultees] });
      queryClient.invalidateQueries({ queryKey: [API_QUERY_KEYS.getManageConsultees] });
      queryClient.invalidateQueries({ queryKey: [API_QUERY_KEYS.getManageTeamConsultees] });
    },
  });
};
